import { useEffect } from 'react'
import { RestrictionsMap } from '../typings'
import {
  RestrictionConfig,
  useRegisterContext,
} from './useRestrictions.constate'

export function useRegister(config?: Omit<RestrictionConfig, 'path'>): void {
  const { register } = useRegisterContext()

  const getBaseName = (name: string): RestrictionsMap => {
    const splitted = name.split('.')
    const restrictionName = Object.values(RestrictionsMap).find(
      (restriction) => !!splitted.includes(restriction)
    )

    if (!restrictionName) {
      throw new Error(`Invalid restriction name: ${name}`)
    }

    return restrictionName
  }

  useEffect(() => {
    if (!config) return

    const path = config.props.name
    const name = getBaseName(path)
    register({
      ...config,
      props: { name },
      path,
    })
  }, [config, register])
}
